import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapPoiComponent } from './map-poi.component';
import {TabModule} from '../tab/tab.module';
import {
  DxButtonModule, DxContextMenuModule,
  DxDataGridModule, DxDrawerModule, DxDropDownButtonModule,
  DxListModule,
  DxPopupModule,
  DxTextBoxModule,
  DxToolbarModule,
  DxValidationGroupModule
} from 'devextreme-angular';
import {LeafletDrawModule} from '@asymmetrik/ngx-leaflet-draw';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {UserDomainsChooserModule} from '../user-domains/user-domains-chooser/user-domains-chooser.module';
import {MapPoiPopupModule} from './map-poi-popup/map-poi-popup.module';
import {IconModule} from '@visurel/iconify-angular';
import {MapSidebarGroupHeaderModule} from '../map/map-sidebar-group-header/map-sidebar-group-header.module';



@NgModule({
  declarations: [MapPoiComponent],
  imports: [
    CommonModule,
    TabModule,
    DxListModule,
    DxToolbarModule,
    DxDataGridModule,
    DxTextBoxModule,
    LeafletModule,
    LeafletDrawModule,
    UserDomainsChooserModule,
    DxValidationGroupModule,
    DxPopupModule,
    MapPoiPopupModule,
    IconModule,
    DxButtonModule,
    DxDropDownButtonModule,
    DxDrawerModule,
    MapSidebarGroupHeaderModule,
    DxContextMenuModule,
  ],
  exports: [MapPoiComponent]
})
export class MapPoiModule { }
